import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import i18n from "@/i18n";
import { buildHead } from "@/lib/seo";
import { PrivacyPage } from "@/components/pages/PrivacyPage";
import { fr } from "@/i18n/fr";

export const Route = createFileRoute("/confidentialite")({
  head: () =>
    buildHead({
      lang: "fr",
      page: "home",
      title: fr.privacy.page.title + " · 2AM Hospitality",
      description: fr.privacy.page.intro,
    }),
  component: () => {
    useEffect(() => {
      if (i18n.language !== "fr") i18n.changeLanguage("fr");
    }, []);
    if (i18n.language !== "fr") i18n.changeLanguage("fr");
    return <PrivacyPage />;
  },
});
